<template>
  <div>
    <div class="row mt-5 mb-2">
      <div class="col d-flex justify-content-center align-items-center">
        <dara-header size="sm">
          {{ $t('choose-articles-for-the-track') }}
        </dara-header>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-9 d-flex align-items-center">
        <dara-input
          id="searchArticles"
          v-model="inputSearch"
          style="width: 95%"
          type="text"
          :placeholder="$t('search-articles-placeholder')"
          @keyup.enter="search()" />
        <dara-icon
          class="flex-fill mx--md"
          icon="search"
          @click="search()" />
      </div>
    </div>

    <div v-if="searchedArticles.length > 0" class="bs-component mt-5 mb-5">
      <dara-draggable :data="searchedArticles" :add="true" @addOrRemove="addArticle($event)"></dara-draggable>
      <dara-pagination
        v-if="searchedArticles"
        :page.sync="pagination.page"
        :total="pagination.total"
        :page-size="pagination.limit"
        @current-change="search" />
    </div>
    <div v-else class="text-center bs-component mt-5 mb-5">
      <dara-p v-if="inputSearch" class="dara-u-text--small" color="danger">
        {{ not_found }}
      </dara-p>
    </div>
  </div>
</template>

<script>
import { toastError } from '@/services/toastService';
import { searchArticles } from '@/modules/article/article.service';
import { translate } from '@/services/translate.service';
import { fetchDepartments } from '@/modules/department/department.service';
import { ARTICLE_ACCESS } from '@/modules/article/article.constants';

export default {
  name: 'DaraArticleSearch',
  data() {
    return {
      inputSearch: null,
      searchedArticles: [],
      departments: null,
      not_found: '',
      pagination: {
        page: 1,
        limit: 5,
      },
    };
  },
  mounted() {
    this.fetchDepartments();
  },
  methods: {
    search() {
      if (this.inputSearch === '' || this.inputSearch === null) {
        this.searchedArticles = [];
      } else {
        searchArticles(this.inputSearch, this.pagination)
          .then(data => {
            this.searchedArticles = data.data;
            if (this.searchedArticles.length === 0) {
              this.not_found = translate('no-articles-found-for-term');
            }
            Object.assign(this.pagination, data.pagination);
          })
          .catch(() => toastError(`${translate('error-on-searching-articles')}`));
      }
    },
    addArticle(article) {
      this.$emit('addArticle', article);
    },
    fetchDepartments() {
      fetchDepartments()
        .then(data => {
          this.departments = data.data;
        })
        .catch(() => {
          this.departments = null;
        });
    },
    getDepartment(departmentId) {
      let department = 'undefined';
      this.departments.forEach(obj => {
        if (obj.id === departmentId) {
          department = obj;
        }
      });
      return department.name;
    },
    getAccess(access) {
      return translate(ARTICLE_ACCESS[access]);
    },
  },
};

</script>
